import * as THREE from 'three';
import { VariantType } from 'notistack';
import { EventStartNotification, EventStartNotificationType } from '../helpers/events';
import { Edit } from './work/Edit';

export function addNotificationDispatch(mess: string, type: VariantType) {
  document.dispatchEvent(
    new CustomEvent<EventStartNotificationType>(EventStartNotification, {
      detail: {
        message: mess,
        messageType: type,
      },
    })
  );
}

export function getPlaneIntersected(
  contour: Array<THREE.Vector3>,
  isHeightPoint?: boolean
): THREE.Mesh {
  const heightPoint = -0.02;
  const geometry = new THREE.Geometry();
  for (let i = 0; i < contour.length; i++) {
    const point = contour[i].clone();
    if (!isHeightPoint) {
      point.setY(heightPoint);
    }
    geometry.vertices.push(point);
  }
  const points2d: Array<THREE.Vector2> = contour.map(point => new THREE.Vector2(point.x, point.z));
  const triangles = THREE.ShapeUtils.triangulateShape(points2d, []);
  for (let i = 0; i < triangles.length; i++) {
    geometry.faces.push(new THREE.Face3(triangles[i][0], triangles[i][1], triangles[i][2]));
  }

  return new THREE.Mesh(
    geometry,
    new THREE.MeshBasicMaterial({ color: Math.random() * 0xffffff, side: THREE.DoubleSide })
  );
}

export function getCenterMass(points: Array<THREE.Vector3>): THREE.Vector3 {
  const trs = [];
  const pointsY = points.map(item => item.y);
  const points2d: Array<THREE.Vector2> = points.map(point => new THREE.Vector2(point.x, point.z));
  const triangles = THREE.ShapeUtils.triangulateShape(points2d, []);
  for (let i = 0; i < triangles.length; i++) {
    const triangle = new THREE.Triangle(
      points[triangles[i][0]],
      points[triangles[i][1]],
      points[triangles[i][2]]
    );
    const middlePoint = new THREE.Vector3();
    const area = triangle.getArea();
    triangle.getMidpoint(middlePoint);
    trs.push({
      middlePoint,
      area,
    });
  }

  const sumArea = trs.reduce((akk, item) => akk + item.area, 0);
  const sumX = trs.reduce((akk, item) => akk + item.middlePoint.x * item.area, 0);
  const sumZ = trs.reduce((akk, item) => akk + item.middlePoint.z * item.area, 0);
  return new THREE.Vector3(sumX / sumArea, Math.min(...pointsY), sumZ / sumArea);
  // console.log('center', center, (sumArea / 1000000).toFixed(4));
  // return center;
}
export function getDumObjects(position: THREE.Vector3, color: string) {
  const m = new THREE.Mesh(
    new THREE.SphereBufferGeometry(0.03),
    new THREE.MeshBasicMaterial({ color })
  );
  m.position.copy(position);
  Edit?.Load?.scene.add(m);
}
